<template>
  <div class="getting-started-overview">
    <div class="getting-started-overview__card">
      <a :href="pricingLink">
        <img src="@/assets/virtual_sports.png" />
        <h3>Plans and Packages</h3>
        <p>Your one-stop-shop for all cricket matches.</p>
        <span class="explore-more">Explore Pricing</span>
      </a>
    </div>
    <div class="getting-started-overview__card">
      <a :href="docsLink">
        <img src="@/assets/docs.png" />
        <h3>Docs</h3>
        <p>You don't need it. You may not read it. All our API's and response are self-explanatory.</p>
        <span class="explore-more">Read more</span>
      </a>
    </div>
    <div class="getting-started-overview__card">
      <Credentials
        :tournament="tournament"
        :association="association"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.getting-started-overview {
  display: flex;
  gap: size(30);
  margin-top: size(30);

  &__card {
    flex: 1;

    a {
      display: block;
      color: var(--global--primary--Color);
      text-decoration: none;

      img {
        width: 100%;
        border-radius: size(8);
        margin-bottom: size(12);
      }

      h3 {
        @include font-styles($type: 'label', $size: 'lg', $weight: 'bold');
        padding-bottom: size(8);
        color: var(--global--main--title--Color);
      }

      p {
        @include font-styles($type: 'label', $size: 'lg', $weight: 'regular');
        color: var(--global--primary--Color);
      }

      .explore-more {
        display: inline-block;
        margin-top: size(12);
        @include font-styles($type: 'label', $size: 'lg', $weight: 'regular');
        color: var(--global--common-link--Color);
        border-bottom: size(1) solid var(--global--common-link--Color);
      }
    }
  }
}
</style>

<script>
import Credentials from '@/components/Credentials.vue';
import Config from '@/config';

export default {
  name: 'GettingStartedOverview',
  components: { Credentials },
  props: {
    tournament: Array,
    association: Array,
  },
  data() {
    return {
      pricingLink: `${Config.cricketApiHost}/v5/package-pricing`,
      docsLink: `${Config.cricketApiHost}/docs/v5/cricket/docs/`,
    };
  },
};
</script>
